import { Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import debounce from 'lodash/debounce';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { message } from 'antd-v5';
import css from '../register.module.scss';
import CountDown from '@/components/CountDown';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import Button from '@/components/UI/Button';
import Checkbox from '@/components/UI/Checkbox';
import Input from '@/components/UI/Input';
import { ENGLISH_LANG, i18nMap, rpcMap } from '@/constants';
import seoconfig from '@/seoconfig/register';
import { checkAccountIsExist, createSubscribe, createSubscribeCommunity, getVerifyCode, toRegisterQuick, toLogin, authSignIn } from '@/service';
import { redirectTo404 } from '@/utils';
import { onLogin } from '@/utils/cookie';
import { getKaamelPlan } from '@/utils/kaamelTest';
import { useGlobal } from '@/utils/useGlobal';
import { usePageBackground } from '@/utils/hooks/usePageBackground';
import EcoCreditDescription from '@/components/EcoCreditDescription';
import SocialLoginLinks from '@/components/SocailLoginLinks';
import EfModal from '@/components/UI/Modal';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { LOGIN_MAP, FORUM_APPID_MAP, SUBSCRIBE_MAP } from '@/constants/forum';
import { getCountryRegion } from '@/utils/countryRegion';

const HOMEBATTERY_REDIRECT = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;
const WORDPRESS_SITE = process.env.NEXT_PUBLIC_WORDPRESS_SITE;
const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;

export default function RegisterPasswordLess({ redirect, SEO }: any) {
    if (redirect.split('redirect=')[1]) {
        redirect = redirect.split('redirect=')[1];
    }

    const recaptchaRef = React.useRef();
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const { useLang, Link, gtm, isMobile } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('register');
    const [inputClass, setInputClass] = useState({
        activeFirst: '',
        activeSecond: '',
        name: '',
    });
    const [loading, setLoading] = useState(false);
    const [sendCodeLoading, setSendCodeLoading] = useState(false);
    const [allValidate, setAllValidate] = useState({
        email: false,
        code: false,
    });
    const [isNewUser, setIsNewUser] = useState(true);
    const [emailValidating, setEmailValidating] = useState<any>(''); // 'success' 'warning' 'error' 'validating'
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [kaamelInfo, setKaamelInfo] = useState<any>(null);
    const router = useRouter();
    const { locale = 'us', query } = router;
    const form = Form.useForm()[0];
    const [resendCode, setResendCode] = useState(0);
    const [open, setOpen] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const { backgroundImage, isLoaded, isAnimating, imageUrl } = usePageBackground(locale);

    const isSelected = ['us', 'ca', 'au', 'jp'].includes(locale);
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    let open_site: string | undefined = '';
    switch (getCountryRegion(locale)) {
        case 'cn':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_CN;
            break;
        case 'eu':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_EU;
            break;
        default:
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE;
            break;
    }

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };

    const goAfterLogin = () => {
        const url = redirect ? redirect : `/${locale}/my-overview`;
        signupCookie({
            entry_name: 'Create EcoFlow Account_Register',
        });
        window.location.href = url;
    };

    // 校验邮箱
    const validateEmail = () => {
        return {
            validator: async (_: any, value: any) => {
                const regx = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                if (!value) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(s('site_login_tip_email_empty'));
                }

                if (!regx.test(value)) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(s('site_login_tip_email_format_incorrect'));
                }

                setAllValidate({
                    ...allValidate,
                    ...{ email: true },
                });

                setEmailValidating('validating');

                try {
                    const res: any = await checkAccountIsExist({ email: value });
                    setEmailValidating('success');

                    if (res.code === '0') {
                        setIsNewUser(false);
                        // setEmailValidating('error');
                        // setAllValidate({
                        //     ...allValidate,
                        //     ...{ email: false },
                        // });
                        // return Promise.reject(s('site_login_tip_email_be_registered'));
                    } else if (res.code === '1003') {
                        setIsNewUser(true);

                        // setAllValidate({
                        //     ...allValidate,
                        //     ...{ email: true },
                        // });
                        // setEmailValidating('success');
                    }
                    return Promise.resolve();
                } catch (err) {
                    setEmailValidating('');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                }
            },
        };
    };

    const formResetFunc = () => {
        // 重置表单内容
        form.resetFields();

        // 重置相关状态
        setEmailValidating('');
        setAllValidate({
            email: false,
            code: false,
        });
        setInputClass({
            activeFirst: '',
            activeSecond: '',
            name: '',
        });
        setResendCode(0);
        setErrorTip('');
        setIsErrorTip(false);
    };

    const validPrePath = (path: string) => {
        if (typeof window !== 'undefined') {
            const origin = (window as any).location.origin;
            return (path.includes(origin) && path) || '';
        }
        return '';
    };

    const getShopfiyReturnToNew = (url: string) => {
        const homePath = `/${router?.locale || ''}`;
        const prevUrlBalckList = ['/login', '/register', '/validate', '/forget'];

        if (typeof window === 'undefined') return homePath;

        let { redirect } = router.query;

        const origin = window.location.origin;
        if (redirect && !prevUrlBalckList.some((item: any) => redirect.includes(item))) {
            if (!redirect.startsWith('http') && !redirect.startsWith('www.')) {
                redirect = `${origin}${redirect.startsWith('/') ? redirect : `/${redirect}`}`;
                return decodeURIComponent(`${redirect}`);
            }
            if ((redirect.startsWith('http') || redirect.startsWith('www.')) && !redirect.includes('.ecoflow.com')) {
                redirect = `${origin}${homePath}`;
                return decodeURIComponent(`${redirect}`);
            }
            return decodeURIComponent(`${redirect}`);
        }

        const prevPath = typeof window !== 'undefined' ? document.referrer : '';

        let prevRoute = validPrePath(prevPath);
        if (prevRoute && !prevUrlBalckList.some((item: any) => prevRoute.includes(item))) {
            if (!prevRoute.startsWith('http') && !prevRoute.startsWith('www.')) {
                prevRoute = `${origin}${prevRoute.startsWith('/') ? prevRoute : `/${prevRoute}`}`;
            }
            if ((prevRoute.startsWith('http') || prevRoute.startsWith('www.')) && !prevRoute.includes('.ecolfow.com')) {
                prevRoute = `${origin}${homePath}`;
            }
            return decodeURIComponent(`${prevRoute}`);
        }
        return url || decodeURIComponent(`${origin}${homePath}`);
    };

    const syncLoginShopify = async (url: string): Promise<string> => {
        return new Promise(async (resolve, reject) => {
            let returnToNew = getShopfiyReturnToNew(url);
            if (returnToNew) {
                returnToNew = returnToNew.startsWith('http') || returnToNew.startsWith('www.') ? returnToNew : `${WEB_HOST}${returnToNew}`;
            } else {
                returnToNew = `${WEB_HOST}/${locale}`;
            }
            const params = {
                returnToNew,
                url: `https://${router?.locale}.ecoflow.com`,
            };
            const res = await authSignIn(params, router?.locale);
            if (res?.code !== '0') {
                reject(res?.message);
            } else {
                resolve(res?.data || `/${router.locale}`);
            }
        });
    };

    const handleFinish = async () => {
        const data = form.getFieldsValue();
        const { _source, inviteCode, scene } = query;

        const { email, code, remember, subscribe } = data;
        const recaptchaRes = { recaptchaResponse };

        setLoading(true);

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_login',
            button_name: s('site_register_btn1'),
            source_channel: 'Website',
            from_page: localStorage.getItem('from_page_login') || 'direct',
        });

        if (isNewUser) {
            const params: any = {
                source: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB',
                userType: 'ECOFLOW',
                scene: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB',
                email: email,
                isAgree: remember,
                code,
                ...recaptchaRes,
                entry_name: 'Create EcoFlow Account',
            };

            if (inviteCode) {
                Object.assign(params, { inviteCode2: inviteCode });
            }

            const res: any = await toRegisterQuick(params, '', locale, _source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY ? FORUM_APPID_MAP[locale] : '');

            setLoading(false);

            if (res.code === '0') {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'sign_up',
                    page_name: '/register',

                    entry_method: 'Page_password-free login/registration',
                    entry_type: 'fixed entry',
                    entry_name: localStorage.getItem('from_page_login') || 'direct',
                    entry_position: 'none',
                    source_channel: 'Website',
                    signup_type: 'password',
                    from_page: localStorage.getItem('from_page_login') || 'direct',
                });
                message.success(s('site_register_without_password_success'));
                if (locale === 'us' || locale === 'ca' || subscribe) {
                    if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
                        await createSubscribeCommunity({ email: email, source: SUBSCRIBE_MAP[_source as string] }, locale);
                    } else {
                        await createSubscribe({
                            email: email,
                            source: 'WEB_REGISTER',
                            eventTracking: subscribeCookie({
                                entry_name: 'Create EcoFlow Account',
                            }),
                        });
                    }
                }
                formResetFunc();
                setOpen(true);
                setTimeout(() => {
                    // onHandleRegister();
                    // const url = redirect ? redirect : `/${locale}/my-overview`;
                    // window.location.href = url;
                    goAfterLogin();
                }, 5000);
                setRecaptchaResponse('');
                const rptRef: any = recaptchaRef?.current;
                rptRef?.reset && rptRef?.reset();
                onLogin(res.data, false);
            } else {
                setErrorTip(res.message || 'error');
                setIsErrorTip(true);
            }
        } else {
            const params = {
                source: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB',
                userType: 'ECOFLOW',
                scene: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB',
                logInSource: 1,
                email: email,
                verificationCode: code,
                ...recaptchaRes,
            };
            const decodeRedirect = decodeURIComponent(redirect);
            const res: any = await toLogin(params, '', _source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY ? FORUM_APPID_MAP[locale] : '');
            setLoading(false);

            if (res.code === '0') {
                const IS_HOME_BATTERY = redirect.indexOf('https://homebattery') > -1 || redirect.indexOf('https://enterprise') > -1;
                onLogin(res.data, IS_HOME_BATTERY);

                if (res.data?.user?.destroyed === 'DESTROY') {
                    window.location.href = `/${router.locale || ''}/my-account-manage`;
                    return;
                }

                gtm.push({
                    event: 'uaEvent',
                    event_name: 'login',
                    page_name: '/login',
                    source_channel: 'Website',
                    from_page: localStorage.getItem('from_page_login') || 'direct',
                    entry_method: 'Page_password-free login/registration',
                });

                if (redirect && scene) {
                    if (redirect.includes(HOMEBATTERY_REDIRECT)) {
                        window.location.href = decodeRedirect;
                        return;
                    }
                    window.location.href = `${WORDPRESS_SITE}?returnTo=${decodeRedirect}&token=${res.data.token}`;
                    return;
                }

                if (window.opener) {
                    window.opener.postMessage(
                        {
                            userInfo: res.data?.user,
                            token: res.data.token,
                        },
                        open_site,
                    );
                }

                try {
                    const res2 = await syncLoginShopify(redirect);
                    window.location.href = String(res2);
                } catch (err) {
                    window.location.href = `/${router.locale || ''}`;
                } finally {
                    setLoading(false);
                }
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);

                gtm.push({
                    event: 'uaEvent',
                    event_name: 'login_fail',
                    page_name: '/login',
                });
            }
        }
    };

    const goLogin = () => {
        localStorage.setItem('from_page_login', 'Page_password-free login/registration');
        gtm.push({
            event: 'uaEvent',
            event_name: 'login_register_switch',
            button_name: s('site_login_login'),
            signup_type: 'Page_login with password',
        });

        let url = `/${locale}/login`;
        if (redirect) url += `?redirect=${encodeURIComponent(redirect)}`;
        router.push(url);
    };

    const goRegister = () => {
        localStorage.setItem('from_page_login', 'Page_password-free login/registration');
        gtm.push({
            event: 'uaEvent',
            event_name: 'login_register_switch',
            button_name: s('site_register_password'),
            signup_type: 'Page_registration with password',
        });
        signupCookie({
            entry_name: 'Create Ecoflow Account',
        });
        const searchParams = new URLSearchParams(window.location.search);
        const queryString = searchParams.toString();
        const targetUrl = `/${locale}/register${queryString ? `?${queryString}` : ''}`;

        router.push(targetUrl);
    };

    const onBlurInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'email') {
                setInputClass({
                    activeFirst: '',
                    activeSecond: inputClass.activeSecond,
                    name: value,
                });
            } else if (value == 'code') {
                setInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: '',
                    name: value,
                });
            }
        }
    };

    const onFocusInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'email') {
                setInputClass({
                    activeFirst: 'active',
                    activeSecond: inputClass.activeSecond,
                    name: value,
                });
            } else if (value == 'code') {
                setInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: 'active',
                    name: value,
                });
            }
        }
    };

    const handleSendVerificationCode = async () => {
        await form.validateFields(['email']);
        await form.validateFields(['recaptchaResponse']);

        try {
            setSendCodeLoading(true);
            const account = form.getFieldValue('email');
            const recaptchaRes = { recaptchaResponse };
            const obj = { scene: isNewUser ? 'WEBSITE_REGISTER_VERIFICATION_CODE' : 'WEBSITE_LOGIN_VERIFICATION_CODE', account, ...recaptchaRes };

            const res: any = await getVerifyCode(obj, locale);
            setSendCodeLoading(false);

            if (res.code === '0') {
                setResendCode(60);
                setIsErrorTip(false);
                setErrorTip('');
            } else {
                setIsErrorTip(true);
                setErrorTip(res.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onHandleRegister = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_sign_up',
                button_name: 'Register',
                signup_type: 'registration with password',
                source_channel: 'Website',
                from_page: localStorage.getItem('from_page_login') || 'direct',
            });
            setOpen(false);
            goAfterLogin();
        } catch (err) {}
    };

    useEffect(() => {
        // 埋点，协议勾选
        if (['us', 'ca', 'au', 'jp'].includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'register_privacy_agree',
                tag: true,
            });
        }
    }, [gtm, locale]);

    useEffect(() => {
        setIsClient(true);
        const info = getKaamelPlan();
        setKaamelInfo(info);
    }, []);

    return (
        <PageLayout className={css.registerPageLayout}>
            <div
                className={`${css.fullscreenBackground} ${isLoaded ? css.loaded : ''} ${isAnimating ? css.fadeIn : ''}`}
                style={
                    {
                        '--bg-image': backgroundImage ? `url(${backgroundImage})` : 'none',
                    } as React.CSSProperties & { '--bg-image': string }
                }
            />
            <SEO title={s('seo_title')} description={s('seo_desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <div className={`${css.register} container login_page_a`}>
                <div className="login-box">
                    <div className={`right`}>
                        <div className="register-box">
                            <h1>{s('site_register_register1')}</h1>
                            <Form name="normal_login" className="login-form" form={form} initialValues={{ remember: isSelected }} onFinish={handleFinish}>
                                <div className="inputItem">
                                    <label className={inputClass.activeFirst == 'active' ? 'active' : ''}>{s('site_login_email')}</label>
                                    <Form.Item name="email" validateStatus={emailValidating} rules={[validateEmail]} validateTrigger="onBlur">
                                        <Input
                                            className="default-input "
                                            autoComplete="off"
                                            aria-label={s('site_login_email')}
                                            onFocus={(e: any) => onFocusInput(e, 'email')}
                                            onBlur={(e: any) => onBlurInput(e, 'email')}
                                            onChange={debounce(() => {
                                                if (!inputClass.activeFirst) {
                                                    setInputClass({
                                                        activeFirst: 'active',
                                                        activeSecond: inputClass.activeSecond,
                                                        name: 'email',
                                                    });
                                                    form.validateFields(['Email']);
                                                }
                                            }, 300)}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="inputItem">
                                    <label className={inputClass.activeSecond === 'active' ? 'active' : ''}>{s('site_register_enter_code')}</label>
                                    <Form.Item name="code" rules={[{ required: true, message: s('site_register_enter_code_tip') }]}>
                                        <Input
                                            className="default-input verify-code"
                                            autoComplete="off"
                                            aria-label={s('site_register_enter_code')}
                                            maxLength={6}
                                            onFocus={(e: any) => onFocusInput(e, 'code')}
                                            onBlur={(e: any) => onBlurInput(e, 'code')}
                                            suffix={
                                                <Button
                                                    type="link"
                                                    className={`send-code-btn ${!allValidate.email || resendCode > 0 ? 'disabled' : ''}`}
                                                    loading={sendCodeLoading}
                                                    disabled={!allValidate.email || resendCode > 0}
                                                    onClick={handleSendVerificationCode}
                                                >
                                                    {resendCode > 0 ? (
                                                        <CountDown sec={resendCode} secUnit="s" onFinish={() => setResendCode(0)} />
                                                    ) : (
                                                        s('site_get_code')
                                                    )}
                                                </Button>
                                            }
                                        />
                                    </Form.Item>
                                </div>
                                <div className="inputItem">
                                    <Form.Item
                                        name="recaptchaResponse"
                                        rules={[
                                            {
                                                validator() {
                                                    if (recaptchaResponse) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                },
                                            },
                                        ]}
                                        style={{ marginBottom: '16px', marginTop: '16px' }}
                                    >
                                        <div className="g-recaptcha">
                                            {/* @ts-ignore */}
                                            <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                        </div>
                                    </Form.Item>
                                    {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                </div>
                                {isNewUser && form.getFieldValue('email') && <div className="new-user-tip">{s('new_user_tip')}</div>}
                                {locale !== 'us' && locale !== 'ca' && (
                                    <Form.Item name="subscribe" valuePropName="checked" noStyle>
                                        <Checkbox className="agreement subscribe">{s('site_register_agree_subscribe')}</Checkbox>
                                    </Form.Item>
                                )}
                                <Form.Item style={{ marginBottom: '16px' }}>
                                    <Form.Item
                                        name="remember"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                validator: (_, value) => (value ? Promise.resolve() : Promise.reject(s('site_login_tip_agree_user_agreement'))),
                                            },
                                        ]}
                                        noStyle
                                    >
                                        <Checkbox
                                            className="agreement"
                                            onChange={(e: CheckboxChangeEvent) => {
                                                // Agree/Disagree/None
                                                const isAgreed = e?.target?.checked ? 'Agree' : 'Disagree';
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'register_privacy_agree',
                                                    tag: isAgreed,
                                                });
                                            }}
                                        >
                                            <span className="checkbox-msg">
                                                {t.rich('logintips.site_login_tip_agree_user_agreement', {
                                                    link1: (children: any) => (
                                                        <Link
                                                            href={
                                                                locale === 'cis'
                                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/PrivacyPolicy.html'
                                                                    : locale === 'uk' && kaamelInfo?.privacyUrl
                                                                    ? kaamelInfo?.privacyUrl
                                                                    : `https://account.ecoflow.com/agreement/${
                                                                          i18nMap[locale] || i18nMap.us
                                                                      }/PrivacyPolicy.html`
                                                            }
                                                            newWin
                                                            ariaLabel={s('privacy')}
                                                        >
                                                            {children}
                                                        </Link>
                                                    ),
                                                    link2: (children: any) => (
                                                        <Link
                                                            href={
                                                                locale === 'cis'
                                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/TermsOfUse.html'
                                                                    : `https://account.ecoflow.com/agreement/${i18nMap[locale] || i18nMap.us}/TermsOfUse.html`
                                                            }
                                                            newWin
                                                            ariaLabel={s('TOU')}
                                                        >
                                                            {children}
                                                        </Link>
                                                    ),
                                                })}
                                            </span>
                                        </Checkbox>
                                    </Form.Item>
                                </Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="register-form-submit"
                                    loading={loading}
                                    aria-label={s('site_register_submit')}
                                    disabled={!allValidate.email}
                                >
                                    {s('site_register_btn1')}
                                </Button>
                                <EcoCreditDescription
                                    title={s('ecocredit_title')}
                                    word1={s('ecocredit_word1')}
                                    word2={s('ecocredit_word2')}
                                    word3={s('ecocredit_word3')}
                                    alternativeWord1={s('ecocredit_word1_1')}
                                />
                                <div className="navigate-content">
                                    <Button type="link" className="other-button" onClick={() => goLogin()} aria-label={s('site_login_login')}>
                                        {s('site_login_login')}
                                    </Button>
                                    <Button type="link" className="other-button" onClick={() => goRegister()} aria-label={s('site_register_password')}>
                                        {s('site_register_password')}
                                    </Button>
                                </div>
                                <div className="divider-line">{`- ${s('site_login_or')} -`}</div>
                                <SocialLoginLinks redirectUrl={redirect} showLineLogin={locale === 'jp'} />
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            {isClient && (
                <EfModal
                    open={open}
                    visible={open}
                    className={css.SuccessModal}
                    width={!isMobile ? 600 : 327}
                    footer={null}
                    closeIcon={
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    onCancel={() => {
                        onHandleRegister();
                    }}
                >
                    <div className="content">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
                                <path
                                    d="M22.501 3.66669C32.6261 3.66669 40.8338 11.8746 40.834 21.9997C40.834 32.1249 32.6262 40.3337 22.501 40.3337C12.3758 40.3337 4.16797 32.1249 4.16797 21.9997C4.16813 11.8746 12.3759 3.66669 22.501 3.66669ZM31.6641 15.9626C30.9481 15.247 29.7872 15.2469 29.0713 15.9626L19.6807 25.3522L15.3887 21.0602C14.6727 20.3444 13.5118 20.3443 12.7959 21.0602C12.0801 21.7762 12.0801 22.9371 12.7959 23.653L18.3223 29.1784C19.0055 29.8615 20.0913 29.8908 20.8115 29.2702C20.9849 29.184 21.1485 29.0709 21.293 28.9265L31.6641 18.5554C32.3799 17.8394 32.38 16.6785 31.6641 15.9626Z"
                                    fill="#30BF00"
                                />
                            </svg>
                        </div>
                        <div className="desc">{s('site_register_success_modal')}</div>
                        <Button onClick={onHandleRegister} className="modal-confirm-btn">
                            {s('site_btn_confirm')}
                        </Button>
                    </div>
                </EfModal>
            )}
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const prevPath = context.req.headers.referer;
    const { redirect } = context.query;
    const { locale } = context;
    if (['cn'].includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {
            redirect: redirect || '',
            prevPath: prevPath || '',
        },
    };
}
